/* ============================================================================
   sp-why-motion.js — motion-laag "Voor zijslapers" (alleen deze pagina). v2.
   Na board-QA + feedback Björn:
   - Minder groepen, meer variatie: hero-choreografie; per sectie ÉÉN copy-blok
     (rise) + foto (settle, transform-only); hoogtekaarten + review-grid (desktop)
     als enige staggers; geen FAQ-motion; geen count-up op de hoogtes (alleen 4,6/5).
   - Catch-up: alles boven de viewport wordt instant getoond (anker-binnenkomst
     via "Ervaringen"; omhoog scrollen is altijd statisch).
   - Mobiel: slider-kaarten NIET per stuk taggen (swiper-klonen/gesture-conflict);
     de slider-wrap als één geheel.
   - Parallax geklemd op [0,700] (iPad rubber-band). Hover erft de reveal-curve
     niet (sp-m-done na transitionend).
   ========================================================================== */
(function () {
  'use strict';
  var root = document.documentElement;
  if (!root.classList.contains('sp-motion')) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    root.classList.remove('sp-motion');
    return;
  }

  var CAP = 4;
  var desktop = window.innerWidth >= 1000;
  var pending = [];

  function q(sel) { return Array.prototype.slice.call(document.querySelectorAll(sel)); }
  function tag(els, step, variant) {
    els.forEach(function (el, i) {
      el.classList.add('sp-m');
      if (variant) el.classList.add('sp-m--' + variant);
      el.style.setProperty('--spm-d', Math.min(i, CAP) * (step || 0) + 'ms');
      pending.push(el);
    });
    return els;
  }
  function group(sel, step, variant) { return tag(q(sel), step, variant); }

  /* --- Hero (entrance op load; buiten de IO-flow) --------------------------- */
  var heroCopy = q('.sp-why-page--hero .sp-why-hero__copy > *');
  heroCopy.forEach(function (el, i) {
    el.classList.add('sp-m');
    el.style.setProperty('--spm-d', Math.min(i, CAP) * 90 + 'ms');
  });
  var heroPlate = document.querySelector('.sp-why-page--hero .sp-why-media-plate--hero');
  if (heroPlate) {
    heroPlate.classList.add('sp-m', 'sp-m--media');
    heroPlate.style.setProperty('--spm-d', '140ms');
  }

  /* --- Secties: één copy-blok + foto (settle); beperkte staggers ------------ */
  group('.sp-why-page--problem .sp-why-copy', 0);
  group('.sp-why-page--problem .sp-why-media-plate', 0, 'media');
  group('.sp-why-page--logic .sp-why-section h2', 0);
  group('.sp-why-ledger--logic', 0);
  group('.sp-why-logic__media', 0, 'media');
  group('[id*="__ss_comparison_table_28"] [class*="comparison-content"]', 0);
  group('[class*="comparison-table-wrapper"]', 0, 'card');
  group('.sp-height-guide__copy', 0);
  group('.sp-height-guide__panel', 0, 'card');
  group('.sp-height-guide__option', 80, 'row');
  group('.sp-why-page--material .sp-why-copy', 0);
  group('.sp-why-page--material .sp-why-media-plate', 0, 'media');
  group('[id*="__why_customer_proof"] [class*="testimonials-heading"]', 0);
  group('[id*="__why_customer_proof"] [class*="testimonials-rating-body"]', 0);
  /* De review-KAARTEN bewust NIET taggen: het is een Section-Store widget met
     eigen (voorheen lazy) init; mijn opacity:0 + IO-reveal erbovenop maakte de
     sectie traag/leeg. De kaarten tonen nu direct wanneer de widget rendert. */
  group('.sp-why-final', 0, 'card');
  /* FAQ: bewust géén motion (taakgericht; widget bezit de DOM). */

  /* --- Count-up: alleen de 4,6/5 score (komma-veilig, exact herstel) -------- */
  var ratingEl = null;
  q('[id*="__why_customer_proof"] [class*="testimonials-rating"] *').forEach(function (el) {
    if (/^\s*\d[.,]\d\/5\s*$/.test(el.textContent) && !el.children.length) ratingEl = el;
  });
  if (ratingEl) ratingEl.classList.add('spm-count');
  function countUp(el) {
    if (!el || el.dataset.spmCounted) return;
    el.dataset.spmCounted = '1';
    var txt = el.textContent;
    var m = txt.match(/^\s*(\d+)([.,](\d+))?/);
    if (!m) return;
    var target = parseFloat(m[1] + (m[3] ? '.' + m[3] : ''));
    var dec = m[3] ? m[3].length : 0;
    var sep = m[2] ? m[2].charAt(0) : '.';
    var suffix = txt.slice(m[0].length);
    var t0 = null, dur = 900;
    function frame(ts) {
      if (t0 === null) t0 = ts;
      var p = Math.min(1, (ts - t0) / dur);
      p = 1 - Math.pow(1 - p, 3);
      el.textContent = (target * p).toFixed(dec).replace('.', sep) + suffix;
      if (p < 1) requestAnimationFrame(frame);
      else el.textContent = txt;
    }
    requestAnimationFrame(frame);
  }

  /* --- Reveal-mechaniek ------------------------------------------------------ */
  function reveal(el, instant) {
    if (instant) el.classList.add('sp-m-instant');
    el.classList.add('sp-m-in');
    var idx = pending.indexOf(el);
    if (idx > -1) pending.splice(idx, 1);
    if (io) io.unobserve(el);
    if (!instant && ratingEl && el.contains(ratingEl)) countUp(ratingEl);
    if (instant && ratingEl && el.contains(ratingEl)) ratingEl.dataset.spmCounted = '1';
  }
  /* Catch-up: alles waarvan de onderkant boven de viewport-top ligt -> instant.
     Dekt anker-binnenkomst (Ervaringen) en maakt omhoog scrollen statisch. */
  function catchUp() {
    pending.slice().forEach(function (el) {
      if (el.getBoundingClientRect().bottom < 60) reveal(el, true);
    });
  }

  var io = null;
  if ('IntersectionObserver' in window) {
    io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) reveal(en.target, false);
      });
    }, { threshold: 0.05, rootMargin: '0px 0px -10% 0px' });
    catchUp();
    pending.slice().forEach(function (el) { io.observe(el); });
    window.addEventListener('load', catchUp);
    // Anker-jump kan ná load plaatsvinden; vangnetten buiten rAF om
    // (rAF bevriest in achtergrond-tabs).
    setTimeout(catchUp, 250);
    setTimeout(catchUp, 1000);
  } else {
    pending.slice().forEach(function (el) { reveal(el, true); });
  }

  /* Hover mag de reveal-curve niet erven: transitie eraf na afloop. */
  document.addEventListener('transitionend', function (e) {
    var el = e.target;
    if (el.classList && el.classList.contains('sp-m-in') && !el.classList.contains('sp-m-done')) {
      el.classList.add('sp-m-done');
    }
  }, true);

  /* --- Hero entrance (setTimeout: rAF bevriest in achtergrond-tabs) --------- */
  setTimeout(function () {
    heroCopy.forEach(function (el) { el.classList.add('sp-m-in'); });
    if (heroPlate) heroPlate.classList.add('sp-m-in');
  }, 60);

  /* --- Parallax: alleen hero-media, desktop, geklemd, rAF ------------------- */
  var heroMediaWrap = document.querySelector('.sp-why-page--hero .sp-why-hero__media');
  var ticking = false;
  window.addEventListener('scroll', function () {
    // Catch-up direct (niet in rAF: bevriest in achtergrond-tabs) zodat
    // anker-jumps en omhoog scrollen altijd statische content tonen.
    catchUp();
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      if (heroMediaWrap && window.innerWidth >= 1024) {
        var y = Math.max(0, Math.min(window.scrollY, 700));
        heroMediaWrap.style.transform = 'translate3d(0,' + (y * 0.05).toFixed(1) + 'px,0)';
      }
      ticking = false;
    });
  }, { passive: true });
})();
